<script>
import ServerMonitor from "@/views/Panel/PanelView/ServerMonitor.vue";

export default {
    name: "ServersBlock",
    components: { ServerMonitor },
};
</script>

<template>
    <div class="block">
        <h2 class="text-center display-3 mb-4">Сервера</h2>
        <div class="row">
            <div class="col-12 col-md-6">
                <server-monitor
                    class="p-3 rounded-4"
                    name="SteamPunk"
                    ip="s3.streamer.fun"
                    port="29030"
                    :background="require('@/assets/servers/steampunk.png')"
                />
            </div>
            <div class="col-12 col-md-6">
                <server-monitor
                    class="p-3 rounded-4"
                    name="HiTech"
                    ip="s3.streamer.fun"
                    port="25800"
                    :background="require('@/assets/servers/tech.jpg')"
                />
            </div>
        </div>
    </div>
</template>

<style scoped></style>
